<template>
  <div>
    <section id="list-product-deposito-detail" class="container flex-column gap-card">
      <CardMitraDetail :data="items" />
      <div class="flex gap-card">
        <div class="flex-column gap-card left-content">
          <CardInfoDeposito
            :data="items"
          />
          <CardEstimasiPerhitungan :data="items"/>
        </div>
        <div class="flex-column gap-card right-content">
          <CardDeskripsi :data="items"/>
        </div>
      </div>
    </section>
    <NewFooterClient />
  </div>
</template>

<script>
import CardMitraDetail from "../public/component-detail-deposito-tabungan/CardMitraDetail.vue";
import CardInfoDeposito from "../public/component-detail-deposito-tabungan/CardInfoDeposito.vue";
import CardEstimasiPerhitungan from "../public/component-detail-deposito-tabungan/CardEstimasiPerhitungan.vue";
import CardDeskripsi from "../public/component-detail-deposito-tabungan/CardDeskripsi.vue";
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";
import ProductDepotiso from "../api/produk";
import DepositoProduct from "../api/depositoProduct";

export default {
  name: 'DetailDeposito',
  components: {
    CardMitraDetail,
    CardInfoDeposito,
    CardEstimasiPerhitungan,
    CardDeskripsi,
    NewFooterClient,
  },
  data() {
    return {
      items: {},
    };
  },
  created(){
    this.loadData();
  },
  mounted(){
    const id = this.$route.query.id;
    // console.log("ID diterima:", id);
  },
  methods: {
    loadData(){
        ProductDepotiso.showDeposito(this.$route.query.id)
        .then((res) => {
          this.items = res.data.data;
          // console.log("response deposito:", this.items);
        })
        .catch((err) => {
          console.error("Gagal load funderShow:", err);
        });
    }
  }
};
</script>

<style scoped>
.container {
  margin-top: 40px;
  max-width: 90%;
}

.flex {
  display: flex;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.gap-card {
  gap: 40px;
}

.left-content {
  width: 30%;
  max-width: 30%;
}

.right-content {
  width: 70%;
}

/* Responsive Layout */
@media (max-width: 1024px) {
  .flex {
    flex-direction: column;
  }

  .left-content,
  .right-content,
  .flex-column {
    width: 100% !important;
    max-width: 100% !important;
  }
}

@media (max-width: 768px) {
  .flex {
    flex-direction: column;
  }

  .left-content,
  .right-content,
  .flex-column {
    width: 100% !important;
    max-width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/list-produk-deposito-detail.vue